// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressLookupController from "./address_lookup_controller"
application.register("address-lookup", AddressLookupController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DocumentUploadController from "./document_upload_controller"
application.register("document-upload", DocumentUploadController)

import FieldPlacementController from "./field_placement_controller"
application.register("field-placement", FieldPlacementController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import PendingPollController from "./pending_poll_controller"
application.register("pending-poll", PendingPollController)

import PricingToggleController from "./pricing_toggle_controller"
application.register("pricing-toggle", PricingToggleController)

import SignersController from "./signers_controller"
application.register("signers", SignersController)

import SigningCeremonyController from "./signing_ceremony_controller"
application.register("signing-ceremony", SigningCeremonyController)

import TestConnectionController from "./test_connection_controller"
application.register("test-connection", TestConnectionController)

import VatLookupController from "./vat_lookup_controller"
application.register("vat-lookup", VatLookupController)
